import React from "react";
import { estadosBonificacionOptions, estadosPendientesOptions } from "../constants";

export default function BonificacionesFilters({ filtros, setFiltros, limpiarFiltros, mostrarEstado = true, opcionesPendientes = false }) {
  const onChange = (key, value) => setFiltros((prev) => ({ ...prev, [key]: value }));
  const estadosOptions = opcionesPendientes ? estadosPendientesOptions : estadosBonificacionOptions;

  return (
    <div className="management-card bonificaciones-filters management-filters-card mb-3">
      <div className="row g-2 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label management-label">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Referente, referido"
            value={filtros.search}
            onChange={(e) => onChange("search", e.target.value)}
          />
        </div>

        <div className="col-6 col-md-4">
          <label className="form-label management-label">Fecha desde</label>
          <input
            type="date"
            className="form-control"
            value={filtros.fecha_desde}
            onChange={(e) => onChange("fecha_desde", e.target.value)}
          />
        </div>

        {mostrarEstado ? (
          <div className="col-6 col-md-4">
            <label className="form-label management-label">Estado</label>
            <div className="input-group">
              <select
                className="form-select"
                value={filtros.estado}
                onChange={(e) => onChange("estado", e.target.value)}
              >
                <option value="all">Todos</option>
                {estadosOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
                <i className="bi bi-eraser me-1" />
                Limpiar
              </button>
            </div>
          </div>
        ) : (
          <div className="col-6 col-md-4">
            <label className="form-label management-label">Fecha hasta</label>
            <div className="input-group">
              <input
                type="date"
                className="form-control"
                value={filtros.fecha_hasta}
                onChange={(e) => onChange("fecha_hasta", e.target.value)}
              />
              <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
                <i className="bi bi-eraser me-1" />
                Limpiar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
